module.exports = __webpack_public_path__ + "img/type-8.f2feeca1.png";